import React from 'react';
import Icon from './Icon';

interface HeroProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  description?: string;
  image?: string;
  actions?: React.ReactNode;
  search?: string;
  slogan?: string;
}

export default function Hero({ eyebrow, title, subtitle, description, image='/assets/hero-city.jpg', actions, search, slogan='Mais árvores para um amanhã melhor' }: HeroProps){
 return <section className="hero" style={{'--hero-image':`url(${image})`} as React.CSSProperties}>
   <div className="hero-overlay"/>
   <div className="hero-content">
    {eyebrow && <div className="hero-eyebrow">{eyebrow}</div>}
    <h1>{title}</h1>
    {subtitle && <h2>{subtitle}</h2>}
    {description && <p>{description}</p>}
    {actions && <div className="hero-actions">{actions}</div>}
   </div>
   {search && <div className="hero-search"><Icon name="search"/><input placeholder={search}/><button>Buscar</button></div>}
   <div className="hero-slogan"><strong>{slogan}</strong><span>NATUREZA<br/>CONECTA<br/>PESSOAS<br/>CIDADES<br/>FUTURO</span></div>
 </section>
}
